import React, { useEffect, useState } from "react";
// import Sidebar from "../../../layouts/sidebar";
import Sidebar from "../../layouts/sidebar";
import Headers from "../../layouts/header";
import "react-datetime/css/react-datetime.css";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
// import useAxiosFile from "../../../actions/useaxios";
import useAxiosFile from "../../actions/useaxios";
// import config from "../../../actions/config";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
// import { DecryptData, EncryptData, isEmpty } from "../../../actions/common";
import { EncryptData, isEmpty } from "../../actions/common";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Col, Row } from "react-bootstrap";
import { FaEye, FaEyeSlash, FaPen, FaTrash } from "react-icons/fa";

function City() {
  const { toggle } = useSelector((state) => state.admin_panel.User);

  const navigate = useNavigate();

  const axiosFile = useAxiosFile();
  const { id } = useParams()
  const [Datas, SetDatas] = useState([]);
  const [Search, SetSearch] = useState("");
  const [city, SetCity] = useState("");
  const [ValidateError, SetValidateError] = useState("");

  var { pathname } = useLocation()
  pathname = pathname.split('/')[1]
  console.log("pathname======", pathname)
  useEffect(() => {
    if (pathname == "city" || pathname == "edit-city") GetLocations();
  }, [Search, pathname]);

  const GetLocations = async () => {

    var resp = await axiosFile.CityAction({ from: 'admin', action: pathname, Search: Search, _id: id });
    console.log("dasdasdsadsa", resp);
    if (pathname == "edit-city") {
      SetCity(resp.data?.[0]?.City)
    } else SetDatas(resp?.data);
    // SetDatas(resp?.data)
  };

  async function _showhide(params, showhome) {
    let resp = await axiosFile.CityAction({ from: 'admin', action: 'showhide', showhome: showhome, _id: params });
    console.log("resp.success ", resp.success, resp?.msg);

    if (resp.success == "success") {
      toast.success(`now will ${showhome ? 'Hide' : 'Show'} in Home page`);
      GetLocations();
      return
    }
    return toast.error(resp?.msg ? resp?.msg : "Something Went Wrong");

  }

  async function _delete(params, showhome) {
    let resp = await axiosFile.CityAction({ from: 'admin', action: 'delete', _id: params });
    console.log("resp.success ", resp.success, resp?.msg);
    if (resp.success == "success") {
      toast.success(`Deleted from Documnet Successfully`);
      GetLocations();
      return
    }
    return toast.error(resp?.msg ? resp?.msg : "Something Went Wrong");

  }
  async function _add(params, showhome) {
    if (isEmpty(city)) {
      SetValidateError({
        City: "City required"
      })
      toast.error("City required");
      return false
    }

    let resp = await axiosFile.CityAction({ from: 'admin', action: 'add', City: city });
    console.log("resp.success ", resp.success, resp?.msg);
    if (resp.success == "success") {
      toast.success(`Added City Successfully`);
      navigate('/city')
      SetCity("")
      // GetLocations();
      return
    }
    SetValidateError(resp.error)
    return toast.error(resp?.msg ? resp?.msg : "Something Went Wrong");

  }
  async function _edit(params, showhome) {
    if (isEmpty(city)) {
      SetValidateError({
        City: "City required"
      })
      toast.error("City required");
      return false
    }

    let resp = await axiosFile.CityAction({ from: 'admin', action: 'edit', _id: id, City: city });
    console.log("resp.success ", resp.success, resp?.msg);
    if (resp.success == "success") {
      toast.success(`Edited from Documnet Successfully`);
      navigate('/city')
      SetCity("")
      // GetLocations();
      return
    }
    SetValidateError(resp.error)
    return toast.error(resp?.msg ? resp?.msg : "Something Went Wrong");

  }



  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) { },
    onSizePerPageChange: function (page, sizePerPage) { },
  });

  const columns = [

    {
      dataField: "CityName",
      text: "City Name",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          {console.log('cellcell', cell, row)}
          <p>{row?.City ? row?.City : "No City"}</p>
        </>
      )
    },
    {
      dataField: "_id",
      text: "",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <div className="d-flex justify-content-center">
          <button
            className="pads_bord_btn d-flex align-items-center justify-content-center gap-2"
            onClick={() => navigate(`/edit-city/${(cell)}`)}>
            <FaPen fontSize={12} />
            Edit
          </button>
        </div>
      )
    },
    {
      dataField: "_id",
      text: "Delete",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <div className="d-flex justify-content-center">
          <button
            className="pads_bord_btn d-flex align-items-center justify-content-center gap-2"
            onClick={() => _delete(cell)}>
            <FaTrash fontSize={12} />
            {'Delete'}
          </button>
        </div>
      )
    },
    {
      dataField: "_id",
      text: "Show in Homepage",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <div className="d-flex justify-content-center">
          <button
            className="pads_bord_btn d-flex align-items-center justify-content-center gap-2"
            onClick={() => _showhide(cell, row.showhome)}>
            {row?.showhome ? <FaEyeSlash fontSize={14} /> : <FaEye fontSize={14} />}
            {row?.showhome ? 'Hide' : 'Show'}
          </button>
        </div>
      )
    },
    {
      dataField: "_id",
      text: "Contents",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <div className="d-flex justify-content-center">
          <button
            className="pads_bord_btn d-flex align-items-center justify-content-center gap-2"
            onClick={() => navigate(`/city-contents/${(cell)}`)}>
            <FaEye fontSize={14} />
            Open Contents
          </button>
        </div>
      )
    },
    // {
    //   dataField: "_id",
    //   text: "FAQ",
    //   sort: true,
    //   formatter: (cell, row, rowindex) => (
    //     <>
    //       <div onClick={()=>navigate(`/city-faq/${(cell)}`)}>
    //       <p>Open FAQ</p>
    //       </div>
    //     </>
    //   )
    // },


  ];





  return (
    <>
      <section id="content-wrapper">
        <div class="row">
          <div className="top_title_sec">
            <div>
              <p className="page_title mb-0">City</p>
            </div>
            {pathname == "city" ?
              <div className="rightside just_end ">
                <button
                  type="button"
                  className="blue_btn add_deliveryprsn dp_btn_hover"
                  onClick={() => navigate(`/add-city`)}
                >
                  Add City
                </button>

              </div> : <></>}
          </div>
        </div>
        {
          pathname == "city" ?

            <div className="row mt-4 mx-auto">
              <div className="sec_border">
                <div className="row">
                  <div className="col-xxl-4 col-xl-4 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div className="whole_searchbar white_bg search_mx_ht">

                      <img
                        className="search_glass"
                        src={require("../../assests/images/Search.png")}
                        alt="dummyimg"

                      />
                      <input placeholder="Search term" onChange={(e) => SetSearch(e.target.value)} value={Search} />
                    </div>
                  </div>


                  {Datas && (
                    <div className="ffd_table mar_bot">
                      <BootstrapTable
                        bootstrap4
                        keyField="id"
                        columns={columns}
                        data={Datas}
                        pagination={pagination}
                        noDataIndication="No City found"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            :
            <div className="sec_border">
              <Row className="mdv_inputrow">
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={6}
                  xs={12}
                  className="mb-3"
                >
                  <p className="mdv_inplabel"> City Name</p>
                  <input
                    className="mdv_cmninput"
                    value={city}
                    type="text"
                    placeholder="Enter City Name"
                    onChange={(e) => SetCity(e?.target?.value)}
                  />
                  {ValidateError && ValidateError.City && (
                    <span className="error-msg">
                      {ValidateError.City}
                    </span>
                  )}
                </Col>




              </Row>
              <div className="mdv_update_dualbtn mt-3">
                <button
                  className="blue_btn mdv_update"
                  onClick={() => { id ? _edit() : _add() }}
                >
                  save
                </button>
              </div>
            </div>}
      </section>
    </>
  );
}

export default City;
